// @ts-nocheck
// import React, { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Stage, Layer, Image, Circle, Rect, Line, Ring } from 'react-konva';
// import useImage from 'use-image';

// const Kuroki = ({ formik, KurokiImage }) => {
//   const { t } = useTranslation();
//   const [image] = useImage(KurokiImage);
//   const [shape, setShape] = useState('ring');
//   const [color, setColor] = useState('red');
//   const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
//   const [mode, setMode] = useState('drawing');
//   const [hoveredComment, setHoveredComment] = useState('');
//   const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0, visible: false });
//   const [scale, setScale] = useState(1);
//   const [markerSize, setMarkerSize] = useState(15);
//   const [showHelp, setShowHelp] = useState(false);
//   const [predefinedComments] = useState(['خدش', 'انبعاج', 'كسر', 'صدأ', 'تآكل', 'تشقق', 'تلف اللون']);
//   const [showPredefinedComments, setShowPredefinedComments] = useState(false);
//   const [innerRadiusRatio, setInnerRadiusRatio] = useState(0.8);
//   const [markerHistory, setMarkerHistory] = useState([]);
//   const [historyIndex, setHistoryIndex] = useState(-1);

//   const markers = formik.values.markers;

//   // Utility function to normalize marker data
//   const normalizeMarker = marker => ({
//     ...marker,
//     x: Number(marker.x),
//     y: Number(marker.y),
//     size: Number(marker.size)
//     // Add other numerical fields if needed
//   });

//   // Load markers from localStorage
//   useEffect(() => {
//     const savedMarkers = localStorage.getItem('carDamageMarkers');
//     if (savedMarkers) {
//       const parsedMarkers = JSON.parse(savedMarkers);
//       const convertedMarkers = parsedMarkers?.map(normalizeMarker);
//       formik.setFieldValue('markers', convertedMarkers);
//     }
//   }, []);

//   // Update marker history
//   useEffect(() => {
//     const normalizedMarkers = markers?.map(normalizeMarker);
//     const newHistory = markerHistory?.slice(0, historyIndex + 1);
//     setMarkerHistory([...newHistory, normalizedMarkers]);
//     setHistoryIndex(newHistory?.length);
//   }, [markers]);

//   const handleUndo = () => {
//     if (historyIndex > 0) {
//       setHistoryIndex(historyIndex - 1);
//       const previousMarkers = markerHistory[historyIndex - 1]?.map(normalizeMarker);
//       formik.setFieldValue('markers', previousMarkers);
//     }
//   };

//   const handleStageClick = event => {
//     const stage = event.target.getStage();
//     const pointerPosition = stage.getPointerPosition();

//     if (!pointerPosition) return;

//     if (mode === 'drawing') {
//       const newMarker = {
//         x: Number(pointerPosition.x), // Ensure number
//         y: Number(pointerPosition.y), // Ensure number
//         shape: shape,
//         color: color,
//         comment: '',
//         size: Number(markerSize) // Ensure number
//       };
//       formik.setFieldValue('markers', [...markers, newMarker]);
//     }
//   };

//   const handleDragMove = (index, event) => {
//     const updatedMarkers = [...markers];
//     updatedMarkers[index] = {
//       ...updatedMarkers[index],
//       x: Number(event.target.x()), // Ensure number
//       y: Number(event.target.y()) // Ensure number
//     };
//     formik.setFieldValue('markers', updatedMarkers);
//   };

//   const handleSave = () => {
//     const normalizedMarkers = markers?.map(normalizeMarker);
//     localStorage.setItem('carDamageMarkers', JSON.stringify(normalizedMarkers));
//     alert(t('تم حفظ أماكن المشاكل والتعليقات بنجاح!'));
//   };

//   const handleClear = () => {
//     if (window.confirm(t('هل أنت متأكد من مسح جميع العلامات؟'))) {
//       formik.setFieldValue('markers', []);
//       localStorage.removeItem('carDamageMarkers');
//     }
//   };

//   const handleCommentChange = (index, comment) => {
//     const updatedMarkers = [...markers];
//     updatedMarkers[index].comment = comment;
//     formik.setFieldValue('markers', updatedMarkers);
//   };

//   const handleMarkerClick = index => {
//     if (mode === 'commenting') {
//       setSelectedMarkerIndex(index);
//     }
//   };

//   const handleMouseEnter = (index, e) => {
//     if (markers[index]?.comment) {
//       setHoveredComment(markers[index].comment);
//       const stage = e.target.getStage();
//       const pointerPos = stage.getPointerPosition();
//       setTooltipPos({
//         x: Number(pointerPos.x), // Ensure number
//         y: Number(pointerPos.y) - 30, // Ensure number
//         visible: true
//       });
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoveredComment('');
//     setTooltipPos(prev => ({ ...prev, visible: false }));
//   };

//   const handleMouseMove = e => {
//     if (hoveredComment) {
//       const stage = e.target.getStage();
//       const pointerPos = stage.getPointerPosition();
//       if (pointerPos) {
//         setTooltipPos({
//           x: Number(pointerPos.x), // Ensure number
//           y: Number(pointerPos.y) - 30, // Ensure number
//           visible: true
//         });
//       }
//     }
//   };

//   const handleDeleteMarker = index => {
//     const updatedMarkers = [...markers];
//     updatedMarkers.splice(index, 1);
//     formik.setFieldValue('markers', updatedMarkers);
//     setSelectedMarkerIndex(null);
//   };

//   return (
//     <div className=' '>
//       <div className='row'>
//         <div className='col-md-5'>
//           <div className='  p-3 rounded shadow-sm mb-3'>
//             <div className='mb-3'>
//               <label className='form-label fw-bold'>{t('الوضع')}</label>
//               <div className='btn-group w-100' role='group'>
//                 <button
//                   type='button'
//                   className={`btn ${mode === 'drawing' ? 'btn-theme' : 'btn-outline-theme'}`}
//                   onClick={() => setMode('drawing')}
//                   aria-label={t('وضع الرسم')}
//                 >
//                   <i className='fa fa-pencil me-2'></i> {t('رسم')}
//                 </button>
//                 <button
//                   type='button'
//                   className={`btn ${mode === 'commenting' ? 'btn-theme' : 'btn-outline-theme'}`}
//                   onClick={() => setMode('commenting')}
//                   aria-label={t('وضع التعليق')}
//                 >
//                   <i className='fa fa-comment me-2'></i> {t('تعليق')}
//                 </button>
//               </div>
//             </div>

//             {mode === 'drawing' && (
//               <>
//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>{t('نوع العلامة')}</label>
//                   <div className='d-flex gap-2'>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'circle' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('circle')}
//                       title={t('دائرة')}
//                       aria-label={t('دائرة')}
//                     >
//                       <i className='fa fa-circle'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'square' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('square')}
//                       title={t('مربع')}
//                       aria-label={t('مربع')}
//                     >
//                       <i className='fa fa-square'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'line' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('line')}
//                       title={t('خط')}
//                       aria-label={t('خط')}
//                     >
//                       <i className='fa fa-minus'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'ring' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('ring')}
//                       title={t('حلقة')}
//                       aria-label={t('حلقة')}
//                     >
//                       <i className='bi bi-circle'></i>
//                     </button>
//                   </div>
//                 </div>

//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>{t('لون العلامة')}</label>
//                   <div className='d-flex gap-2'>
//                     {['red', 'blue', 'green', 'yellow', 'purple']?.map(c => (
//                       <button
//                         type='button'
//                         key={c}
//                         className={`btn p-2 position-relative ${color === c ? 'border-3 border-dark' : 'border-1'}`}
//                         onClick={() => setColor(c)}
//                         style={{
//                           backgroundColor: c,
//                           width: '32px',
//                           height: '32px'
//                         }}
//                         title={t(c)}
//                         aria-label={t(c)}
//                       ></button>
//                     ))}
//                   </div>
//                 </div>

//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>
//                     {t('حجم العلامة')}: {markerSize}px
//                   </label>
//                   <input
//                     type='range'
//                     className='form-range'
//                     min='3'
//                     max='15'
//                     value={markerSize}
//                     onChange={e => setMarkerSize(parseInt(e.target.value))}
//                   />
//                 </div>
//               </>
//             )}

//             {mode === 'commenting' && selectedMarkerIndex !== null && (
//               <div className='mb-3'>
//                 <div className='d-flex justify-content-between align-items-center mb-2'>
//                   <label className='form-label fw-bold'>{t('التعليــق')}</label>
//                   <div>
//                     <button
//                       type='button'
//                       className='btn btn-sm btn-outline-primary me-2'
//                       onClick={() => setShowPredefinedComments(!showPredefinedComments)}
//                       aria-label={t('عرض التعليقات الجاهزة')}
//                     >
//                       <i className='fa fa-list me-1'></i>
//                       {t('تعليقات جاهزة')}
//                     </button>
//                     <button
//                       type='button'
//                       className='btn btn-sm btn-outline-danger'
//                       onClick={() => handleDeleteMarker(selectedMarkerIndex)}
//                       aria-label={t('حذف العلامة')}
//                     >
//                       <i className='fa fa-trash'></i>
//                     </button>
//                   </div>
//                 </div>

//                 {showPredefinedComments && (
//                   <div className='mb-3'>
//                     <div className='d-flex flex-wrap gap-2'>
//                       {predefinedComments?.map((comment, idx) => (
//                         <button
//                           type='button'
//                           key={idx}
//                           className='btn btn-sm btn-outline-secondary'
//                           onClick={() => {
//                             handleCommentChange(selectedMarkerIndex, comment);
//                             setShowPredefinedComments(false);
//                           }}
//                         >
//                           {comment}
//                         </button>
//                       ))}
//                     </div>
//                     <hr className='my-2' />
//                   </div>
//                 )}

//                 <textarea
//                   className='form-control'
//                   rows='3'
//                   value={markers[selectedMarkerIndex]?.comment || ''}
//                   onChange={e => handleCommentChange(selectedMarkerIndex, e.target.value)}
//                   placeholder={t('أدخل وصفًا للضرر...')}
//                 />
//               </div>
//             )}

//             <div className='d-flex gap-2 mt-4'>
//               {/* <button
//                   type='button'
//                   className='btn btn-success flex-grow-1'
//                   onClick={handleSave}
//                   disabled={markers.length === 0}
//                 >
//                   <i className='fa fa-save me-2'></i> {t('حفظ')}
//                 </button> */}
//               <button
//                 type='button'
//                 className={`btn flex-grow-1 ${historyIndex > 0 ? 'btn-warning' : 'btn-secondary'}`}
//                 onClick={handleUndo}
//                 disabled={historyIndex <= 0}
//               >
//                 <i className='fa fa-undo me-2'></i> {t('تراجــع')}
//               </button>
//               <button
//                 type='button'
//                 className='btn btn-danger flex-grow-1'
//                 onClick={handleClear}
//                 disabled={markers?.length === 0}
//               >
//                 <i className='fa fa-trash me-2'></i> {t('مسح الكل')}
//               </button>
//             </div>
//           </div>

//           <div className='alert alert-info mt-3'>
//             <div className='d-flex justify-content-between align-items-center'>
//               <span>
//                 <i className='fa fa-info-circle me-2'></i>
//                 {mode === 'drawing'
//                   ? t('انقر على الصورة لإضافة علامة في مكان الضرر')
//                   : t('انقر على علامة موجودة لإضافة تعليق')}
//               </span>
//               <button type='button' className='btn btn-sm btn-outline-info' onClick={() => setShowHelp(!showHelp)}>
//                 {showHelp ? t('إخفاء المساعدة') : t('عرض المزيد')}
//               </button>
//             </div>

//             {showHelp && (
//               <div className='mt-2'>
//                 <ul className='mb-0'>
//                   <li>{t('في وضع الرسم: انقر لإضافة علامة')}</li>
//                   <li>{t('في وضع التعليق: انقر على علامة لتحديدها')}</li>
//                   <li>{t('اسحب العلامات لتعديل موقعها')}</li>
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className='col-md-7'>
//           <div className='position-relative border border-secondary rounded overflow-hidden bg-theme bg-opacity-20'>
//             <Stage
//               className='d-flex justify-content-center align-items-center'
//               width={600}
//               height={400}
//               onClick={handleStageClick}
//               onMouseMove={handleMouseMove}
//               style={{ cursor: mode === 'drawing' ? 'crosshair' : 'pointer' }}
//             >
//               <Layer>
//                 <Image image={image} width={600} height={400} />

//                 {markers?.map((marker, index) => {
//                   // Validate marker before rendering
//                   if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
//                     console.warn(`Invalid marker at index ${index}:`, marker);
//                     return null;
//                   }

//                   const isSelected = selectedMarkerIndex === index;
//                   const markerColor = isSelected ? 'yellow' : marker.color;
//                   const currentSize = isSelected ? Number(marker.size) + 2 : Number(marker.size);

//                   if (marker.shape === 'circle') {
//                     return (
//                       <Circle
//                         key={index}
//                         x={Number(marker.x)}
//                         y={Number(marker.y)}
//                         radius={currentSize}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'square') {
//                     return (
//                       <Rect
//                         key={index}
//                         x={Number(marker.x) - currentSize}
//                         y={Number(marker.y) - currentSize}
//                         width={currentSize * 2}
//                         height={currentSize * 2}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'line') {
//                     return (
//                       <Line
//                         key={index}
//                         points={[
//                           Number(marker.x) - currentSize * 2,
//                           Number(marker.y),
//                           Number(marker.x) + currentSize * 2,
//                           Number(marker.y)
//                         ]}
//                         stroke={markerColor}
//                         strokeWidth={currentSize / 2}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'ring') {
//                     return (
//                       <Ring
//                         key={index}
//                         x={Number(marker.x)}
//                         y={Number(marker.y)}
//                         innerRadius={currentSize * Number(innerRadiusRatio)}
//                         outerRadius={currentSize}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   }
//                   return null;
//                 })}
//               </Layer>
//             </Stage>

//             {tooltipPos.visible && hoveredComment && (
//               <div
//                 className='position-absolute bg-dark text-white p-2 rounded small'
//                 style={{
//                   left: Number(tooltipPos.x),
//                   top: Number(tooltipPos.y),
//                   maxWidth: '200px',
//                   zIndex: 100,
//                   pointerEvents: 'none'
//                 }}
//               >
//                 {hoveredComment}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Kuroki;

// import { useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
// import { Stage, Layer, Image, Circle, Rect, Line, Ring } from 'react-konva';
// import useImage from 'use-image';

// const Kuroki = ({ formik, KurokiImage }) => {
//   const { t } = useTranslation();
//   const [image] = useImage(KurokiImage);
//   const [shape, setShape] = useState('ring');
//   const [color, setColor] = useState('red');
//   const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
//   const [mode, setMode] = useState('drawing');
//   const [hoveredComment, setHoveredComment] = useState('');
//   const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0, visible: false });
//   const [scale, setScale] = useState(1);
//   const [markerSize, setMarkerSize] = useState(15);
//   const [showHelp, setShowHelp] = useState(false);
//   // const [predefinedComments] = useState(['خدش', 'انبعاج', 'كسر', 'صدأ', 'تآكل', 'تشقق', 'تلف اللون']);

//   const [predefinedComments] = useState([
//     t('Scratch'),
//     t('Dent'),
//     t('Break'),
//     t('Rust'),
//     t('Corrosion'),
//     t('Crack'),
//     t('ColorDamage')
//   ]);
//   const [showPredefinedComments, setShowPredefinedComments] = useState(false);
//   const [innerRadiusRatio, setInnerRadiusRatio] = useState(0.8);
//   const [markerHistory, setMarkerHistory] = useState([]);
//   const [historyIndex, setHistoryIndex] = useState(-1);

//   const markers = formik.values.markers;

//   // Utility function to normalize marker data
//   const normalizeMarker = marker => ({
//     ...marker,
//     x: Number(marker.x),
//     y: Number(marker.y),
//     size: Number(marker.size)
//   });

//   // Load markers from localStorage
//   useEffect(() => {
//     const savedMarkers = localStorage.getItem('carDamageMarkers');
//     if (savedMarkers) {
//       const parsedMarkers = JSON.parse(savedMarkers);
//       const convertedMarkers = parsedMarkers?.map(normalizeMarker);
//       formik.setFieldValue('markers', convertedMarkers);
//     }
//   }, []);

//   // Update marker history
//   useEffect(() => {
//     const normalizedMarkers = markers?.map(normalizeMarker);
//     const newHistory = markerHistory?.slice(0, historyIndex + 1);
//     setMarkerHistory([...newHistory, normalizedMarkers]);
//     setHistoryIndex(newHistory?.length);
//   }, [markers]);

//   const handleUndo = () => {
//     if (historyIndex > 0) {
//       setHistoryIndex(historyIndex - 1);
//       const previousMarkers = markerHistory[historyIndex - 1]?.map(normalizeMarker);
//       formik.setFieldValue('markers', previousMarkers);
//     }
//   };

//   const handleStageClick = event => {
//     const stage = event.target.getStage();
//     const pointerPosition = stage.getPointerPosition();

//     if (!pointerPosition) return;

//     if (mode === 'drawing') {
//       const newMarker = {
//         x: Number(pointerPosition.x),
//         y: Number(pointerPosition.y),
//         shape: shape,
//         color: color,
//         comment: '',
//         size: Number(markerSize)
//       };
//       formik.setFieldValue('markers', [...markers, newMarker]);
//     }
//   };

//   const handleDragMove = (index, event) => {
//     const updatedMarkers = [...markers];
//     updatedMarkers[index] = {
//       ...updatedMarkers[index],
//       x: Number(event.target.x()),
//       y: Number(event.target.y())
//     };
//     formik.setFieldValue('markers', updatedMarkers);
//   };

//   // const handleSave = () => {
//   //   const normalizedMarkers = markers?.map(normalizeMarker);
//   //   localStorage.setItem('carDamageMarkers', JSON.stringify(normalizedMarkers));
//   //   alert(t('تم حفظ أماكن المشاكل والتعليقات بنجاح!'));
//   // };

//   const handleClear = () => {
//     if (window.confirm(t('ClearConfirmation'))) {
//       formik.setFieldValue('markers', []);
//       localStorage.removeItem('carDamageMarkers');
//     }
//   };

//   const handleCommentChange = (index, comment) => {
//     const updatedMarkers = [...markers];
//     updatedMarkers[index].comment = comment;
//     formik.setFieldValue('markers', updatedMarkers);
//   };

//   const handleMarkerClick = index => {
//     if (mode === 'commenting') {
//       setSelectedMarkerIndex(index);
//     }
//   };

//   const handleMouseEnter = (index, e) => {
//     if (markers[index]?.comment) {
//       setHoveredComment(markers[index].comment);
//       setTooltipPos({
//         x: 10, // الزاوية العلوية اليسرى
//         y: 10,
//         visible: true
//       });
//     }
//   };

//   const handleMouseLeave = () => {
//     setHoveredComment('');
//     setTooltipPos(prev => ({ ...prev, visible: false }));
//   };

//   const handleMouseMove = () => {
//     // لا حاجة لتحديث الموقع لأن الـ tooltip ثابت الآن
//   };

//   const handleDeleteMarker = index => {
//     const updatedMarkers = [...markers];
//     updatedMarkers.splice(index, 1);
//     formik.setFieldValue('markers', updatedMarkers);
//     setSelectedMarkerIndex(null);
//   };

//   return (
//     <div className=' '>
//       <div className='row'>
//         <div className='col-md-5'>
//           <div className=' p-3 rounded shadow-sm mb-3'>
//             <div className='mb-3'>
//               <label className='form-label fw-bold'>{t('Mode')}</label>
//               <div className='btn-group w-100' role='group'>
//                 <button
//                   type='button'
//                   className={`btn ${mode === 'drawing' ? 'btn-theme' : 'btn-outline-theme'}`}
//                   onClick={() => setMode('drawing')}
//                   aria-label={t('DrawingMode')}
//                 >
//                   <i className='fa fa-pencil me-2'></i> {t('Draw')}
//                 </button>
//                 <button
//                   type='button'
//                   className={`btn ${mode === 'commenting' ? 'btn-theme' : 'btn-outline-theme'}`}
//                   onClick={() => setMode('commenting')}
//                   aria-label={t('CommentingMode')}
//                 >
//                   <i className='fa fa-comment me-2'></i> {t('Comment')}
//                 </button>
//               </div>
//             </div>

//             {mode === 'drawing' && (
//               <>
//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>{t('MarkerType')}</label>
//                   <div className='d-flex gap-2'>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'circle' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('circle')}
//                       title={t('Circle')}
//                       aria-label={t('Circle')}
//                     >
//                       <i className='fa fa-circle'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'square' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('square')}
//                       title={t('Square')}
//                       aria-label={t('Square')}
//                     >
//                       <i className='fa fa-square'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'line' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('line')}
//                       title={t('Line')}
//                       aria-label={t('Line')}
//                     >
//                       <i className='fa fa-minus'></i>
//                     </button>
//                     <button
//                       type='button'
//                       className={`btn ${shape === 'ring' ? 'btn-theme' : 'btn-outline-theme'}`}
//                       onClick={() => setShape('ring')}
//                       title={t('Ring')}
//                       aria-label={t('Ring')}
//                     >
//                       <i className='bi bi-circle'></i>
//                     </button>
//                   </div>
//                 </div>

//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>{t('MarkerColor')}</label>
//                   <div className='d-flex gap-2'>
//                     {/* {['red', 'blue', 'green', 'yellow', 'purple']?.map(c => ( */}
//                     {['red', 'blue', 'green' ]?.map(c => (
//                       <button
//                         type='button'
//                         key={c}
//                         className={`btn p-2 position-relative ${color === c ? 'border-3 border-dark' : 'border-1'}`}
//                         onClick={() => setColor(c)}
//                         style={{
//                           backgroundColor: c,
//                           width: '32px',
//                           height: '32px'
//                         }}
//                         title={t(c)}
//                         aria-label={t(c)}
//                       ></button>
//                     ))}
//                   </div>
//                 </div>

//                 <div className='mb-3'>
//                   <label className='form-label fw-bold'>
//                     {t('MarkerSize')}: {markerSize}px
//                   </label>
//                   <input
//                     type='range'
//                     className='form-range'
//                     min='3'
//                     max='15'
//                     value={markerSize}
//                     onChange={e => setMarkerSize(parseInt(e.target.value))}
//                   />
//                 </div>
//               </>
//             )}

//             {mode === 'commenting' && selectedMarkerIndex !== null && (
//               <div className='mb-3'>
//                 <div className='d-flex justify-content-between align-items-center mb-2'>
//                   <label className='form-label fw-bold'>{t('CommentLabel')}</label>{' '}
//                   <div>
//                     <button
//                       type='button'
//                       className='btn btn-sm btn-outline-primary me-2'
//                       onClick={() => setShowPredefinedComments(!showPredefinedComments)}
//                       aria-label={t('ShowPredefinedComments')}
//                     >
//                       <i className='fa fa-list me-1'></i>
//                      {t('PredefinedComments')}
//                     </button>
//                     <button
//                       type='button'
//                       className='btn btn-sm btn-outline-danger'
//                       onClick={() => handleDeleteMarker(selectedMarkerIndex)}
//                       aria-label={t('DeleteMarker')}
//                     >
//                       <i className='fa fa-trash'></i>
//                     </button>
//                   </div>
//                 </div>

//                 {showPredefinedComments && (
//                   <div className='mb-3'>
//                     <div className='d-flex flex-wrap gap-2'>
//                       {predefinedComments?.map((comment, idx) => (
//                         <button
//                           type='button'
//                           key={idx}
//                           className='btn btn-sm btn-outline-secondary'
//                           onClick={() => {
//                             handleCommentChange(selectedMarkerIndex, comment);
//                             setShowPredefinedComments(false);
//                           }}
//                         >
//                           {comment}
//                         </button>
//                       ))}
//                     </div>
//                     <hr className='my-2' />
//                   </div>
//                 )}

//                 <textarea
//                   className='form-control'
//                   rows='3'
//                   value={markers[selectedMarkerIndex]?.comment || ''}
//                   onChange={e => handleCommentChange(selectedMarkerIndex, e.target.value)}
//                  placeholder={t('DamageDescriptionPlaceholder')}
//                 />
//               </div>
//             )}

//             <div className='d-flex gap-2 mt-4'>
//               <button
//                 type='button'
//                 className={`btn flex-grow-1 ${historyIndex > 0 ? 'btn-warning' : 'btn-secondary'}`}
//                 onClick={handleUndo}
//                 disabled={historyIndex <= 0}
//               >
//                 <i className='fa fa-undo me-2'></i>{t('Undo')}
//               </button>
//               <button
//                 type='button'
//                 className='btn btn-danger flex-grow-1'
//                 onClick={handleClear}
//                 disabled={markers?.length === 0}
//               >
//                 <i className='fa fa-trash me-2'></i>{t('ClearAll')}
//               </button>
//             </div>
//           </div>

//         <div className='alert alert-info mt-3'>
//             <div className='d-flex justify-content-between align-items-center'>
//               <span>
//                 <i className='fa fa-info-circle me-2'></i>
//                 {mode === 'drawing' ? t('DrawingInstruction') : t('CommentingInstruction')}
//               </span>
//               <button type='button' className='btn btn-sm btn-outline-info' onClick={() => setShowHelp(!showHelp)}>
//                 {showHelp ? t('HideHelp') : t('ShowMore')}
//               </button>
//             </div>

//             {showHelp && (
//               <div className='mt-2'>
//                 <ul className='mb-0'>
//                   <li>{t('HelpDrawInstruction')}</li>
//                   <li>{t('HelpCommentInstruction')}</li>
//                   <li>{t('HelpDragInstruction')}</li>
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>

//         <div className='col-md-7'>
//           <div className='position-relative border border-secondary rounded overflow-hidden bg-theme bg-opacity-20'>
//             <Stage
//               className='d-flex justify-content-center align-items-center'
//               width={600}
//               height={400}
//               onClick={handleStageClick}
//               onMouseMove={handleMouseMove}
//               style={{ cursor: mode === 'drawing' ? 'crosshair' : 'pointer' }}
//             >
//               <Layer>
//                 <Image image={image} width={600} height={400} />

//                 {markers?.map((marker, index) => {
//                   if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
//                     console.warn(`Invalid marker at index ${index}:`, marker);
//                     return null;
//                   }

//                   const isSelected = selectedMarkerIndex === index;
//                   const markerColor = isSelected ? 'yellow' : marker.color;
//                   const currentSize = isSelected ? Number(marker.size) + 2 : Number(marker.size);

//                   if (marker.shape === 'circle') {
//                     return (
//                       <Circle
//                         key={index}
//                         x={Number(marker.x)}
//                         y={Number(marker.y)}
//                         radius={currentSize}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'square') {
//                     return (
//                       <Rect
//                         key={index}
//                         x={Number(marker.x) - currentSize}
//                         y={Number(marker.y) - currentSize}
//                         width={currentSize * 2}
//                         height={currentSize * 2}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'line') {
//                     return (
//                       <Line
//                         key={index}
//                         points={[
//                           Number(marker.x) - currentSize * 2,
//                           Number(marker.y),
//                           Number(marker.x) + currentSize * 2,
//                           Number(marker.y)
//                         ]}
//                         stroke={markerColor}
//                         strokeWidth={currentSize / 2}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   } else if (marker.shape === 'ring') {
//                     return (
//                       <Ring
//                         key={index}
//                         x={Number(marker.x)}
//                         y={Number(marker.y)}
//                         innerRadius={currentSize * Number(innerRadiusRatio)}
//                         outerRadius={currentSize}
//                         fill={markerColor}
//                         stroke={isSelected ? 'black' : 'transparent'}
//                         strokeWidth={1}
//                         draggable
//                         onDragMove={e => handleDragMove(index, e)}
//                         onClick={() => handleMarkerClick(index)}
//                         onMouseEnter={e => handleMouseEnter(index, e)}
//                         onMouseLeave={handleMouseLeave}
//                       />
//                     );
//                   }
//                   return null;
//                 })}
//               </Layer>
//             </Stage>

//             {tooltipPos.visible && hoveredComment && (
//               <div
//                 className='position-absolute bg-dark text-white p-2 rounded small'
//                 style={{
//                   left: tooltipPos.x, // ثابت عند 10px من اليسار
//                   top: tooltipPos.y, // ثابت عند 10px من الأعلى
//                   maxWidth: '200px',
//                   zIndex: 100,
//                   pointerEvents: 'none'
//                 }}
//               >
//                 {hoveredComment}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Kuroki;

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Stage, Layer, Image, Circle, Rect, Line, Ring } from 'react-konva';
import useImage from 'use-image';

const Kuroki = ({ formik, KurokiImage, viewOnly = false }) => {
  const { t } = useTranslation();
  const [image] = useImage(KurokiImage);
  const [shape, setShape] = useState('ring');
  const [color, setColor] = useState('red');
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
  const [mode, setMode] = useState('drawing');
  const [hoveredComment, setHoveredComment] = useState('');
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0, visible: false });
  const [scale, setScale] = useState(1);
  const [markerSize, setMarkerSize] = useState(15);
  const [showHelp, setShowHelp] = useState(false);
  // const [predefinedComments] = useState(['خدش', 'انبعاج', 'كسر', 'صدأ', 'تآكل', 'تشقق', 'تلف اللون']);

  const [predefinedComments] = useState([
    t('Scratch'),
    t('Dent'),
    t('Break'),
    t('Rust'),
    t('Corrosion'),
    t('Crack'),
    t('ColorDamage')
  ]);
  const [showPredefinedComments, setShowPredefinedComments] = useState(false);
  const [innerRadiusRatio, setInnerRadiusRatio] = useState(0.8);
  const [markerHistory, setMarkerHistory] = useState([]);
  const [historyIndex, setHistoryIndex] = useState(-1);

  const markers = formik.values.markers;

  // Utility function to normalize marker data
  const normalizeMarker = marker => ({
    ...marker,
    x: Number(marker.x),
    y: Number(marker.y),
    size: Number(marker.size)
  });

  // Load markers from localStorage
  useEffect(() => {
    const savedMarkers = localStorage.getItem('carDamageMarkers');
    if (savedMarkers) {
      const parsedMarkers = JSON.parse(savedMarkers);
      const convertedMarkers = parsedMarkers?.map(normalizeMarker);
      formik.setFieldValue('markers', convertedMarkers);
    }
  }, []);

  // Update marker history
  useEffect(() => {
    const normalizedMarkers = markers?.map(normalizeMarker);
    const newHistory = markerHistory?.slice(0, historyIndex + 1);
    setMarkerHistory([...newHistory, normalizedMarkers]);
    setHistoryIndex(newHistory?.length);
  }, [markers]);

  const handleUndo = () => {
    if (historyIndex > 0) {
      setHistoryIndex(historyIndex - 1);
      const previousMarkers = markerHistory[historyIndex - 1]?.map(normalizeMarker);
      formik.setFieldValue('markers', previousMarkers);
    }
  };

  const handleStageClick = event => {
    if (viewOnly) return;

    const stage = event.target.getStage();
    const pointerPosition = stage.getPointerPosition();

    if (!pointerPosition) return;

    if (mode === 'drawing') {
      const newMarker = {
        x: Number(pointerPosition.x),
        y: Number(pointerPosition.y),
        shape: shape,
        color: color,
        comment: '',
        size: Number(markerSize)
      };
      formik.setFieldValue('markers', [...markers, newMarker]);
    }
  };

  const handleDragMove = (index, event) => {
    if (viewOnly) return;

    const updatedMarkers = [...markers];
    updatedMarkers[index] = {
      ...updatedMarkers[index],
      x: Number(event.target.x()),
      y: Number(event.target.y())
    };
    formik.setFieldValue('markers', updatedMarkers);
  };

  const handleClear = () => {
    if (viewOnly) return;

    if (window.confirm(t('ClearConfirmation'))) {
      formik.setFieldValue('markers', []);
      localStorage.removeItem('carDamageMarkers');
    }
  };

  const handleCommentChange = (index, comment) => {
    if (viewOnly) return;

    const updatedMarkers = [...markers];
    updatedMarkers[index].comment = comment;
    formik.setFieldValue('markers', updatedMarkers);
  };

  const handleMarkerClick = index => {
    if (viewOnly) return;

    if (mode === 'commenting') {
      setSelectedMarkerIndex(index);
    }
  };

  const handleMouseEnter = (index, e) => {
    if (markers[index]?.comment) {
      setHoveredComment(markers[index].comment);
      setTooltipPos({
        x: 10, // الزاوية العلوية اليسرى
        y: 10,
        visible: true
      });
    }
  };

  const handleMouseLeave = () => {
    setHoveredComment('');
    setTooltipPos(prev => ({ ...prev, visible: false }));
  };

  const handleMouseMove = () => {
    // لا حاجة لتحديث الموقع لأن الـ tooltip ثابت الآن
  };

  const handleDeleteMarker = index => {
    if (viewOnly) return;

    const updatedMarkers = [...markers];
    updatedMarkers.splice(index, 1);
    formik.setFieldValue('markers', updatedMarkers);
    setSelectedMarkerIndex(null);
  };

  return (
    <div className=' '>
      <div className='row'>
        {!viewOnly && (
          <div className='col-md-5'>
            <div className=' p-3 rounded shadow-sm mb-3'>
              <div className='mb-3'>
                <label className='form-label fw-bold'>{t('Mode')}</label>
                <div className='btn-group w-100' role='group'>
                  <button
                    type='button'
                    className={`btn ${mode === 'drawing' ? 'btn-theme' : 'btn-outline-theme'}`}
                    onClick={() => setMode('drawing')}
                    aria-label={t('DrawingMode')}
                  >
                    <i className='fa fa-pencil me-2'></i> {t('Draw')}
                  </button>
                  <button
                    type='button'
                    className={`btn ${mode === 'commenting' ? 'btn-theme' : 'btn-outline-theme'}`}
                    onClick={() => setMode('commenting')}
                    aria-label={t('CommentingMode')}
                  >
                    <i className='fa fa-comment me-2'></i> {t('Comment')}
                  </button>
                </div>
              </div>

              {mode === 'drawing' && (
                <>
                  <div className='mb-3'>
                    <label className='form-label fw-bold'>{t('MarkerType')}</label>
                    <div className='d-flex gap-2'>
                      <button
                        type='button'
                        className={`btn ${shape === 'circle' ? 'btn-theme' : 'btn-outline-theme'}`}
                        onClick={() => setShape('circle')}
                        title={t('Circle')}
                        aria-label={t('Circle')}
                      >
                        <i className='fa fa-circle'></i>
                      </button>
                      <button
                        type='button'
                        className={`btn ${shape === 'square' ? 'btn-theme' : 'btn-outline-theme'}`}
                        onClick={() => setShape('square')}
                        title={t('Square')}
                        aria-label={t('Square')}
                      >
                        <i className='fa fa-square'></i>
                      </button>
                      <button
                        type='button'
                        className={`btn ${shape === 'line' ? 'btn-theme' : 'btn-outline-theme'}`}
                        onClick={() => setShape('line')}
                        title={t('Line')}
                        aria-label={t('Line')}
                      >
                        <i className='fa fa-minus'></i>
                      </button>
                      <button
                        type='button'
                        className={`btn btn-sm ${shape === 'ring' ? 'btn-theme' : 'btn-outline-theme'} `}
                        onClick={() => setShape('ring')}
                        title={t('Ring')}
                        aria-label={t('Ring')}
                      >
                        <i className='bi bi-circle'></i>
                      </button>
                    </div>
                  </div>

                  <div className='mb-3'>
                    <label className='form-label fw-bold'>{t('MarkerColor')}</label>
                    <div className='d-flex gap-2'>
                      {['red', 'blue', 'green']?.map(c => (
                        <button
                          type='button'
                          key={c}
                          className={`btn btn-sm p-2 position-relative ${color === c ? 'border-3 border-dark' : 'border-1'}`}
                          onClick={() => setColor(c)}
                          style={{
                            backgroundColor: c,
                            width: '32px',
                            height: '32px'
                          }}
                          title={t(c)}
                          aria-label={t(c)}
                        ></button>
                      ))}
                    </div>
                  </div>

                  <div className='mb-3'>
                    <label className='form-label fw-bold'>
                      {t('MarkerSize')}: {markerSize}px
                    </label>
                    <input
                      type='range'
                      className='form-range'
                      min='3'
                      max='15'
                      value={markerSize}
                      onChange={e => setMarkerSize(parseInt(e.target.value))}
                    />
                  </div>
                </>
              )}

              {mode === 'commenting' && selectedMarkerIndex !== null && (
                <div className='mb-3'>
                  <div className='d-flex justify-content-between align-items-center mb-2'>
                    <label className='form-label fw-bold'>{t('CommentLabel')}</label>{' '}
                    <div>
                      <button
                        type='button'
                        className='btn btn-sm btn-outline-primary me-2'
                        onClick={() => setShowPredefinedComments(!showPredefinedComments)}
                        aria-label={t('ShowPredefinedComments')}
                      >
                        <i className='fa fa-list me-1'></i>
                        {t('PredefinedComments')}
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-outline-danger'
                        onClick={() => handleDeleteMarker(selectedMarkerIndex)}
                        aria-label={t('DeleteMarker')}
                      >
                        <i className='fa fa-trash'></i>
                      </button>
                    </div>
                  </div>

                  {showPredefinedComments && (
                    <div className='mb-3'>
                      <div className='d-flex flex-wrap gap-2'>
                        {predefinedComments?.map((comment, idx) => (
                          <button
                            type='button'
                            key={idx}
                            className='btn btn-sm btn-outline-secondary'
                            onClick={() => {
                              handleCommentChange(selectedMarkerIndex, comment);
                              setShowPredefinedComments(false);
                            }}
                          >
                            {comment}
                          </button>
                        ))}
                      </div>
                      <hr className='my-2' />
                    </div>
                  )}

                  <textarea
                    className='form-control'
                    rows='3'
                    value={markers[selectedMarkerIndex]?.comment || ''}
                    onChange={e => handleCommentChange(selectedMarkerIndex, e.target.value)}
                    placeholder={t('DamageDescriptionPlaceholder')}
                  />
                </div>
              )}

              <div className='d-flex gap-2 mt-4'>
                <button
                  type='button'
                  className={`btn flex-grow-1 ${historyIndex > 0 ? 'btn-warning' : 'btn-secondary'}`}
                  onClick={handleUndo}
                  disabled={historyIndex <= 0}
                >
                  <i className='fa fa-undo me-2'></i>
                  {t('Undo')}
                </button>
                <button
                  type='button'
                  className='btn btn-danger flex-grow-1'
                  onClick={handleClear}
                  disabled={markers?.length === 0}
                >
                  <i className='fa fa-trash me-2'></i>
                  {t('ClearAll')}
                </button>
              </div>
            </div>

            <div className='alert alert-info mt-3'>
              <div className='d-flex justify-content-between align-items-center'>
                <span>
                  <i className='fa fa-info-circle me-2'></i>
                  {mode === 'drawing' ? t('DrawingInstruction') : t('CommentingInstruction')}
                </span>
                <button type='button' className='btn btn-sm btn-outline-info' onClick={() => setShowHelp(!showHelp)}>
                  {showHelp ? t('HideHelp') : t('ShowMore')}
                </button>
              </div>

              {showHelp && (
                <div className='mt-2'>
                  <ul className='mb-0'>
                    <li>{t('HelpDrawInstruction')}</li>
                    <li>{t('HelpCommentInstruction')}</li>
                    <li>{t('HelpDragInstruction')}</li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        )}

        <div className={viewOnly ? 'col-12' : 'col-md-7'}>
          <div className='position-relative border border-secondary rounded overflow-hidden bg-theme bg-opacity-20'>
            <Stage
              className='d-flex justify-content-center align-items-center'
              width={600}
              height={400}
              onClick={handleStageClick}
              onMouseMove={handleMouseMove}
              style={{ cursor: viewOnly ? 'default' : mode === 'drawing' ? 'crosshair' : 'pointer' }}
            >
              <Layer>
                <Image image={image} width={600} height={400} />

                {markers?.map((marker, index) => {
                  if (!marker || isNaN(marker.x) || isNaN(marker.y) || isNaN(marker.size)) {
                    console.warn(`Invalid marker at index ${index}:`, marker);
                    return null;
                  }

                  const isSelected = selectedMarkerIndex === index;
                  const markerColor = isSelected ? 'yellow' : marker.color;
                  const currentSize = isSelected ? Number(marker.size) + 2 : Number(marker.size);

                  if (marker.shape === 'circle') {
                    return (
                      <Circle
                        key={index}
                        x={Number(marker.x)}
                        y={Number(marker.y)}
                        radius={currentSize}
                        fill={markerColor}
                        stroke={isSelected ? 'black' : 'transparent'}
                        strokeWidth={1}
                        draggable={!viewOnly}
                        onDragMove={e => handleDragMove(index, e)}
                        onClick={() => handleMarkerClick(index)}
                        onMouseEnter={e => handleMouseEnter(index, e)}
                        onMouseLeave={handleMouseLeave}
                      />
                    );
                  } else if (marker.shape === 'square') {
                    return (
                      <Rect
                        key={index}
                        x={Number(marker.x) - currentSize}
                        y={Number(marker.y) - currentSize}
                        width={currentSize * 2}
                        height={currentSize * 2}
                        fill={markerColor}
                        stroke={isSelected ? 'black' : 'transparent'}
                        strokeWidth={1}
                        draggable={!viewOnly}
                        onDragMove={e => handleDragMove(index, e)}
                        onClick={() => handleMarkerClick(index)}
                        onMouseEnter={e => handleMouseEnter(index, e)}
                        onMouseLeave={handleMouseLeave}
                      />
                    );
                  } else if (marker.shape === 'line') {
                    return (
                      <Line
                        key={index}
                        points={[
                          Number(marker.x) - currentSize * 2,
                          Number(marker.y),
                          Number(marker.x) + currentSize * 2,
                          Number(marker.y)
                        ]}
                        stroke={markerColor}
                        strokeWidth={currentSize / 2}
                        draggable={!viewOnly}
                        onDragMove={e => handleDragMove(index, e)}
                        onClick={() => handleMarkerClick(index)}
                        onMouseEnter={e => handleMouseEnter(index, e)}
                        onMouseLeave={handleMouseLeave}
                      />
                    );
                  } else if (marker.shape === 'ring') {
                    return (
                      <Ring
                        key={index}
                        x={Number(marker.x)}
                        y={Number(marker.y)}
                        innerRadius={currentSize * Number(innerRadiusRatio)}
                        outerRadius={currentSize}
                        fill={markerColor}
                        stroke={isSelected ? 'black' : 'transparent'}
                        strokeWidth={1}
                        draggable={!viewOnly}
                        onDragMove={e => handleDragMove(index, e)}
                        onClick={() => handleMarkerClick(index)}
                        onMouseEnter={e => handleMouseEnter(index, e)}
                        onMouseLeave={handleMouseLeave}
                      />
                    );
                  }
                  return null;
                })}
              </Layer>
            </Stage>

            {tooltipPos.visible && hoveredComment && (
              <div
                className='position-absolute bg-dark text-white p-2 rounded small'
                style={{
                  left: tooltipPos.x, // ثابت عند 10px من اليسار
                  top: tooltipPos.y, // ثابت عند 10px من الأعلى
                  maxWidth: '200px',
                  zIndex: 100,
                  pointerEvents: 'none'
                }}
              >
                {hoveredComment}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Kuroki;
